import * as React from 'react'
import IconPanel from '@mulesoft/anypoint-icons/lib/Icon'
import './LogPointsTopBar.css'

export type ValueProps = {
  hasSavedYet: boolean
  hasChanges: boolean
  isSaving: boolean
  error?: any
  messageHref?: string
}

export type Props = ValueProps

const savingMessage = 'Please, wait until the new configuration is saved.'
const hasChangesMessage = 'Once saved, applying the new configuration may take up to 1 minute.'
const errorMessage = 'An error occurred, please try again.'
const savedMessage = 'Configuration has been saved. It can take up to 1 minute for the logs to appear.'

const getTopBarMessage = (props: Props): string => {
  const {hasSavedYet, hasChanges, isSaving, error} = props

  if (isSaving) return savingMessage
  else if (error) return errorMessage
  else if (hasChanges) return hasChangesMessage
  else if (hasSavedYet) return savedMessage
  else return ''
}

export const LogPointsTopBarMessage = (props: Props) => {
  const {hasSavedYet, hasChanges, isSaving, error, messageHref} = props
  const topBarMessage = getTopBarMessage(props)
  const isSaved = hasSavedYet && !error && !hasChanges && !isSaving
  const messageContainerClassName = error ? 'error-message' : isSaved ? 'link' : ''

  return (
      <div
        className={`log-points-page-top-bar-message-container ${messageContainerClassName}`}
        data-test-id="log-points-page-top-bar-message-container"
      >
        {
          error &&
          <IconPanel
            className="log-points-page-top-bar-message-icon"
            testId={'log-points-page-top-bar-message-icon'}
            name="warning-small"
            fill="#d1344e"
            size="xs"
          />
        }
        <span className="log-points-page-top-bar-message" data-test-id="log-points-page-top-bar-message">{topBarMessage}</span>
        {
          isSaved && messageHref &&
          <a
            className="log-points-page-top-bar-link"
            data-test-id="log-points-page-top-bar-link"
            href={messageHref}
          >
            View Logs
          </a>
        }
      </div>
  )
}
